// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"8977fc34","758":"9a119688","798":"bf28bcd3","928":"bdae620b"}[chunkId] + ".js";
};